import React, { createContext, useState, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../config";
import { CRICKET_API_URL } from "../config";

export const ContestContext = createContext();

export const ContestProvider = ({ children }) => {
    // Cache for contest details (id -> data)
    const [contestCache, setContestCache] = useState({});
    const [loading, setLoading] = useState(false);

    // --- FETCH CONTEST DETAIL ---
    const getContestDetail = useCallback(async (contestId) => {
        // Agar pehle se data hai to API call mat karo (Smooth Load)
        if (contestCache[contestId]) {
            return contestCache[contestId];
        }

        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/api/contests/${contestId}`);
            if (res.data.success) {
                const data = res.data.data;
                // Save to cache
                setContestCache(prev => ({ ...prev, [contestId]: data }));
                return data;
            }
        } catch (error) {
            console.error("Contest Fetch Error:", error);
        } finally {
            setLoading(false);
        }
        return null;
    }, [contestCache]);

    // --- JOIN CONTEST ---
    // ✅ FRESH CONTEST CONTEXT (Order ekdum sahi hai)
    const joinContest = async (userId, userName, contestId, teamId, matchId, token) => {
        try {
            // Check lagaya taaki pata chale yahan tak ID aayi ya nahi
            console.log("Context Sending to Backend ->", { userId, userName, contestId, teamId, matchId });

            const res = await axios.post(`${CRICKET_API_URL}/api/cricket/contests/join`, {
                userId: userId,
                userName: userName,
                contestId: contestId,
                userTeamId: teamId,
                matchId: matchId
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            return res.data;
        } catch (error) {
            throw error.response?.data?.error || "Join Failed";
        }
    };

    return (
        <ContestContext.Provider value={{
            contestCache,
            getContestDetail,
            joinContest,
            loading
        }}>
            {children}
        </ContestContext.Provider>
    );
};